/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from '@reduxjs/toolkit';
import rentalsReservations from './rentalsReservations';

const rentalsReducers = {
    rentalsReservations,
};

export default combineReducers(rentalsReducers);
